import React, { useState } from 'react';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import Form from 'react-bootstrap/Form';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import ReplyIcon from '@mui/icons-material/Reply';
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from '@mui/material';
import { showDangerToast } from '../../constants/toaster';

// Options for Dropdown
const options = [
  { value: '', label: 'Select User' },
  { value: '1', label: 'Ganesh' },
];
const defaultOption = options[0];

const EditEmail = ({ editEmailFormData, setEditEmailFormData, handleSubmitEmail, setEditEmailEnable }) => {
  const [value, setValue] = useState('all');
  const [showUserDropdown, setShowUserDropdown] = useState(false);

  // Handle Radio Change
  const handleRadioChange = (event) => {
    setValue(event.target.value);
    setShowUserDropdown(event.target.value === 'toUser');
  };

  // Handle Submit
  const handleSubmit = () => {
    const { title, subject, content } = editEmailFormData;
    if (title && subject && content) {
      handleSubmitEmail();
    } else {
      showDangerToast('Please fill all required fields.');
    }
  };

  return (
    <div className="container-fluid mt--7">
      <div className="row">
        <div className="col text-left">
          <div className="card shadow">
            {/* Header */}
            <div className="card-header border-0">
              <div className="row align-items-center">
                <div className="col text-left">
                  <button
                    onClick={() => setEditEmailEnable(false)}
                    className="btn btn-sm btn-primary text-white"
                  >
                    <ReplyIcon />
                    Cancel
                  </button>
                </div>
                <div className="col text-center">
                  <h3 className="mb-0">Edit Email Template</h3>
                </div>
                <div className="col text-right">
                  <button onClick={handleSubmit} className="btn btn-sm btn-primary text-white">
                    Submit
                  </button>
                </div>
              </div>
            </div>

            {/* Form */}
            <div className="card-body">
              <div className="row">
                {/* Template Name */}
                <div className="col-md-6">
                  <FormInput
                    label="Template Name*"
                    placeholder="Template Name"
                    value={editEmailFormData.title}
                    onChange={(value) =>
                      setEditEmailFormData({ ...editEmailFormData, title: value })
                    }
                    errorMessage="Title is required*"
                    isRequired
                  />
                </div>

                {/* Subject */}
                <div className="col-md-6">
                  <FormInput
                    label="Subject*"
                    placeholder="Subject"
                    value={editEmailFormData.subject}
                    onChange={(value) =>
                      setEditEmailFormData({ ...editEmailFormData, subject: value })
                    }
                    errorMessage="Subject is required*"
                    isRequired
                  />
                </div>
              </div>

              {/* Content */}
              <div className="row mt-4">
                <div className="col-md-12">
                  <FormGroup
                    label="Content*"
                    isRequired
                    errorMessage="Content is required*"
                  >
                    <CKEditor
                      editor={ClassicEditor}
                      data={editEmailFormData?.content}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        setEditEmailFormData({ ...editEmailFormData, content: data });
                      }}
                    />
                  </FormGroup>
                </div>
              </div>
            </div>

            {/* Optional Dropdown */}
            {showUserDropdown && (
              <div className="row mt-4">
                <div className="col-md-12">
                  <Dropdown
                    options={options}
                    onChange={(selected) =>
                      setEditEmailFormData({
                        ...editEmailFormData,
                        selectedUser: selected.value,
                      })
                    }
                    value={defaultOption}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditEmail;

// Reusable Form Input Component
const FormInput = ({ label, placeholder, value, onChange, errorMessage, isRequired }) => (
  <Form.Group className="mb-3">
    <Form.Label>{label}</Form.Label>
    <Form.Control
      type="text"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
    {isRequired && !value && <label className="custom-error-label">{errorMessage}</label>}
  </Form.Group>
);

// Reusable Form Group Component for CKEditor
const FormGroup = ({ label, isRequired, errorMessage, children }) => (
  <Form.Group className="mb-3">
    <Form.Label>{label}</Form.Label>
    {children}
    {isRequired && <label className="custom-error-label">{errorMessage}</label>}
  </Form.Group>
);
